module.exports = __webpack_public_path__ + "img/vlog.6453eb39.png";